import { ref, watch, computed, nextTick } from '@vue/composition-api'
import store from '@/store'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import router from '@/router'
import axios from '@axios'

export default function usePinFloorplan() {
    const buildings = ref([]);
    const isBuildingFormSidebarActive = ref(false);
    const isFloorplanFormSidebarActive = ref(false)
    const buildingsData = ref({});
    const langs = ref([]);
    const place_id = ref(router.currentRoute.params.id);
    const place = ref({});
    const buildingItem = ref({})

    const getPlaceDetail = async() => {
        const resp = await axios.get('place/v1/getdetail/'+place_id.value);

        if(resp.data.data){
            place.value = resp?.data?.data;
        }
    }

    const addBuilding = (data )=> {
        if (!data) {
            data = {};
        }

        data.place_id = place_id.value;
        buildingsData.value = JSON.parse(JSON.stringify(data));

        isBuildingFormSidebarActive.value = false;
        nextTick(() => {
            isBuildingFormSidebarActive.value = true;
        });
    }

    const addFloorPlan = (item) => {
        buildingItem.value = item;
        isFloorplanFormSidebarActive.value = true;
    }

    const updateBuilding = (data)=>{
        buildingsData.value = data;
        isBuildingFormSidebarActive.value = true;
    }

    const refetchData = async()=>{
        const response = await store.dispatch('app-place/fetchBuilding', place_id.value)

        if(response.data.success){
            buildings.value = response?.data?.data.filter(b => b && typeof b === 'object');
        }
    }

    const getLangs = ()=>{
        store.dispatch('app-languages/fetchData', { is_active: 1 })
            .then((res) => {
                if(res.data.success){
                    langs.value = res?.data?.data;
                }
        });
    }

    refetchData()
    getPlaceDetail()
    getLangs();

    return {
        buildings,
        addBuilding,
        isBuildingFormSidebarActive,
        buildingsData,
        refetchData,
        langs,
        place,
        updateBuilding,
        getPlaceDetail,
        addFloorPlan,
        isFloorplanFormSidebarActive,
        buildingItem,
    }
}